(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/game-analyses-redux/assets/game-analyses-constants.js') >= 0) return;  svs.modules.push('/components/sportinfo/game-analyses-redux/assets/game-analyses-constants.js');
"use strict";


const PREDICTION_SROW = 'SROW';
setGlobal('svs.components.sportinfo.gameAnalysesRedux.constants', {
  PREDICTION_SROW
});

 })(window);